import closeIcon from "../../icons/closeWhite.svg";
import React, { ChangeEvent, MouseEvent, useEffect, useState } from "react";
import SecondaryButton from "../SecondaryButton";
import classes from "./addingTag.module.css";
import { ITag } from "../../tags/types";
import { useTagsQuery } from "../../../queries";

interface IProps {
  onAdded: (tag: string) => (event: MouseEvent) => void;
  onClose: () => void;
  addedTags: string[];
}

const AddingTag = ({ onAdded, onClose, addedTags }: IProps) => {
  const [tags, setTags] = useState<ITag[]>([]);
  const [currentValue, setCurrentValue] = useState("");
  const [filteredTags, setFilteredTags] = useState<any>([]);

  const { isSuccess, data } = useTagsQuery();

  useEffect(() => {
    if (currentValue.length > 0) {
      const newTags = tags.filter((el: ITag) => {
        if (addedTags.indexOf(el.name) !== -1) {
          return false;
        }

        return el.name.toLowerCase().includes(currentValue.toLowerCase());
      });
      setFilteredTags(newTags.slice(0, 3));
    } else {
      setFilteredTags([]);
    }
  }, [currentValue, tags, addedTags]);

  useEffect(() => {
    if (isSuccess && data) {
      setTags(data.tags);
    }
  }, [isSuccess, data]);

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    setCurrentValue(event.currentTarget.value);
  };

  return (
    <SecondaryButton variant="default">
      <div className={classes.wrapper}>
        <div className={classes.btn}>
          <input className={classes.input} type="text" value={currentValue} onChange={handleChange} />
          <div className={classes.remove} onClick={onClose}>
            <img className={classes.removeIcon} src={closeIcon} alt="" />
          </div>
        </div>
        {filteredTags.length > 0 && (
          <ul className={classes.dropdown}>
            {
              filteredTags.map((tag: any, index: number) => {
                return <li
                  key={index}
                  className={classes.dropdownItem}
                  onClick={onAdded(tag.name)}
                >
                  {tag.name}
                </li>;
              })
            }
          </ul>
        )}
      </div>
    </SecondaryButton>
  );
};

export default AddingTag;
